import locale from "localization/en";

export const stationsColumn = [
  { key: "code", text: locale.stationCode, width: "100px" },
  { key: "name", text: locale.stationName, width: "100px" },
  { key: "type", text: locale.stationType, width: "50px" },
  { key: "subscription", text: locale.subscriptionType, width: "50px" },
  { key: "status", text: `${locale.status} / ${locale.dateTime}`, width: "200px" },
  { key: "lastChecked", text: locale.lastChecked, width: "200px" },
  { key: "lastTransaction", text: locale.lastTransaction, width: "200px" },
  { key: "connectedToPTS", text: locale.connectedToPTS, width: "50px" },
  { key: "connectedToPump", text: locale.connectedToPump, width: "50px" },
  { key: "actions", text: locale.actions, width: "50px" },
];
